import Swal from "sweetalert2";
import { apiService } from "./service";
import { navigate_to_edit_profile, navigate_to_profile } from "../../navigator/user/profile";
import { navigate_to_product } from "../../navigator/user/product";
import { navigate_to_shop } from "../../navigator/user/shop";

export function actionHandler(action, data, categoryTitle) {
  // TODO: remove `categoryTitle` from `params` of this function and any `arguments`
  switch (action) {
    case "url":
      window.location.href = data.url;
      return;
    case "user/shops":
      let path = "/search";
      if (data.category) {
        if (data.title) {
          path = `/search?categoryUid=${data.category}&categoryTitle=${data.title}`;
        } else {
          path = `/search?categoryUid=${data.category}`;
        }
      } else {
        if (data.title) {
          path = `/search?categoryTitle=${data.title}`;
        }
      }
      return path;
    case "user/new-shop":
      return `/new-shop`;
    case "user/profile":
      return navigate_to_profile();
    case "user/edit_profile":
      return navigate_to_edit_profile();
    case "user/accounts":
      return `/profile?accounts=1`;
    case "user/orders":
      return `/orders`;
    case "user/order":
      return `/orders/${data.uid}`;
    case "user/carts":
      return `/carts`;
    case "user/cart":
      return `/${data.uid}/cart`;
    case "page":
      return `${
        window.location.pathname.includes("dashboard")
          ? "/dashboard/" + window.location.pathname.split("/")[2]
          : window.location.pathname.split("/")[1] === "categories" ||
          window.location.pathname === "/"
            ? ""
            : "/" + window.location.pathname.split("/")[1]
      }/page/${data.id}`;
    case "user/shop":
      return navigate_to_shop(data.uid);
    case "user/product":
      return navigate_to_product(data.shop_uid, data.uid, false);
    case "user/shop-products":
      return `/${data.uid}?tab=products`;
    case "user/addresses":
      return `/addresses`;
    case "user/address":
      return `/addresses/${data.uid}`;
    case "user/feedback":
      return `/feedback`;
    case "user/setting":
      return `/setting`;
    case "seller/accounts":
      return `/dashboard/${data.shop_uid}?accounts=1`;
    case "seller/orders":
      return `/dashboard/${data.shop_uid}/orders`;
    case "seller/order":
      return `/dashboard/${data.shop_uid}/orders/${data.uid}`;
    case "seller/products":
      return `/dashboard/${data.shop_uid}/products`;
    case "seller/product":
      return `/${data.shop_uid}/p/${data.uid}?isManager=true`;
    case "seller/edit_product":
      return `/dashboard/${data.shop_uid}/p/${data.uid}`;
    case "seller/add_product":
      return `/dashboard/${data.shop_uid}/p`;
    case "seller/comments":
      return `/dashboard/${data.shop_uid}/comments`;
    case "seller/customers":
      return `/dashboard/${data.shop_uid}/customers`;
    case "seller/shop_info":
      return `/dashboard/${data.shop_uid}/edit`;
    case "seller/rules":
      return `/dashboard/${data.shop_uid}/terms`;
    case "seller/admins":
      return `/dashboard/${data.shop_uid}/managers`;
    case "seller/contacts":
      return `/dashboard/${data.shop_uid}/connections`;
    case "seller/shipping_configs":
      return `/dashboard/${data.shop_uid}/posting-methods`;
    case "seller/payment_configs":
      return `/dashboard/${data.shop_uid}/payments`;
    case "seller/setting":
      return `/setting?seller=1`;
    case "view/refresh":
      window.location.reload();
      return;
    case "api":
      apiService(data.path.substring(1), data.method, "", true).then(
        (items) => {
          if (items && items.response) {
            var errors = items.response.data.errors;
            const errSwal = Swal.mixin({
              customClass: {
                confirmButton:
                  "btn rounded28 px-4 py-2 fw-bold bg-color-main text-white",
                container: "px-4",
                popup: "rounded14"
              },
              buttonsStyling: false
            });
            errSwal.fire({
              confirmButtonText: "متوجه شدم",
              html:
                "<p class=\"fw-bold text-dark\">موارد نیاز به اصلاح</p>" +
                `${errors.shop.map(
                  (error, e) =>
                    `<p class="fw-bold text-end text-danger small">${error.message}</p>`
                )}`
            });
          } else {
            window.location.reload();
          }
        }
      );
      return;
    case "toast":
      Swal.fire({
        text: data.message,
        showConfirmButton: false,
        toast: true,
        customClass: {
          htmlContainer: "text-center m-0 w-auto"
        },
        width: 200,
        timer: 3500,
        timerProgressBar: true
      });
      break;
    default:
      break;
  }
}

export default actionHandler;
